/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const SocialExportTwitterSettingsDtoReplySettingsEnum = {
    everyone: "everyone",
    following: "following",
    mentionedUsers: "mentionedUsers",
    subscribers: "subscribers",
    verified: "verified"
} as const;

export type SocialExportTwitterSettingsDtoReplySettingsEnumKey = (typeof SocialExportTwitterSettingsDtoReplySettingsEnum)[keyof typeof SocialExportTwitterSettingsDtoReplySettingsEnum];

export type SocialExportTwitterSettingsDto = {
    /**
     * @description Controls who can reply to the tweet
     * @default "everyone"
     * @type string
    */
    replySettings?: SocialExportTwitterSettingsDtoReplySettingsEnumKey | null;
};